module.exports = __webpack_public_path__ + "img/step1-2.0a6b3744.png";